import { Routes, Route } from 'react-router-dom'
import { Suspense } from 'react'
import { ProgressBarSuspenseFallback } from '@vivaldis/web-ui'
import { ProtectedRoute } from '../../components/ProtectedRoute'
import { useCompanyHasWeatherObstructionsEnabled } from '../../providers/CompanyInformationQueryProvider'
import { lazyOrReloadPage } from '../../utils/lazyOrReloadPage'

const CreateWorkObstruction = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "CreateWorkObstruction" */ './screens/CreateWeatherObstruction'
    )
)
const WeatherObstructionContractCandidateList = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "WeatherObstructionContractCandidateList" */ './screens/WeatherObstructionContractCandidateList'
    )
)

export const WeatherObstructionRoutes = () => {
  const companyHasWeatherObstructionsEnabled =
    useCompanyHasWeatherObstructionsEnabled()

  return (
    <Suspense fallback={ProgressBarSuspenseFallback}>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute isAllowed={companyHasWeatherObstructionsEnabled}>
              <WeatherObstructionContractCandidateList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-weather-obstruction/:id"
          element={<CreateWorkObstruction />}
        />
      </Routes>
    </Suspense>
  )
}
